import html2canvas from 'html2canvas';

export default async function exportMap(ref) {
  let img = '';
  await html2canvas(ref, { useCORS: true }).then((canvas) => {
    img = canvas.toDataURL('image/png');
  });
  return img;
}
